import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ImportScheduleKey, ImportScheduleState } from "./import-schedule-reducer";

export const selectImportScheduleState = createFeatureSelector<ImportScheduleState>(ImportScheduleKey);

export const selectFileName = createSelector(selectImportScheduleState, (state) => state.fileName);